
/**
 * ID Generator utility
 * Generates alphanumeric IDs of length 7 with a prefix.
 * Ensures uniqueness across multiple contexts.
 */
class IdGenerator {
  constructor(context) {
    this.index = 0;
    this.prefix = context || this.generateRandomPrefix();
  }

  /**
   * Generate the next unique ID.
   * @returns {string} Unique ID with prefix.
   */
  next() {
    const id = this.index.toString(36);
    this.index += 1;
    const padded = `000000${id}`;
    return `${this.prefix}${padded.slice(-7)}`;
  }

  /**
   * Generate a random 5-character prefix.
   * @returns {string} Random prefix.
   */
  generateRandomPrefix() {
    return Math.random().toString(36).substring(2, 7);
  }
}

export default IdGenerator;
